import { localStorage  } from "../types/localStorage/localStorage";

const localStorageConfig: localStorage = {
    languageChecksum: 'checksumLanguage',
    languageData: 'languageData',
    languageIso: 'languageIso',
    brainGameData: 'brainGameData',
};

export { localStorageConfig };